import { render, staticRenderFns } from "./UserPermission.vue?vue&type=template&id=5b3e5f23&scoped=true&"
import script from "./UserPermission.vue?vue&type=script&lang=js&"
export * from "./UserPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3e5f23",
  null
  
)

export default component.exports